import { defaultHttpClient } from '../../httpClient';

export interface AddToCartGoodsOption {
  is_force: boolean;
  delivery_type: string;
  count: number;
  text_option: string | null;
  sno: number;
}

export interface AddToCartRequest {
  goods_sno: number;
  goods_options: AddToCartGoodsOption[];
}

export interface AddToCartResponse {
  message: string | null;
  carts_count: number;
}

export const postAddToCart = (body: AddToCartRequest) => {
  return defaultHttpClient
    .request<AddToCartResponse>({
      method: 'POST',
      url: '/api/v2/carts/',
      data: body,
    })
    .then(result => result.data);
};
